'use strict';

import Cookies from 'js-cookie';
import { loadJS } from './asset-loaders';
import InterNACHI from 'shared/InterNACHI.js';

const session = Cookies.get('session-js');

if (session) {
	loadJS(session, { async: false, defer: false });
} else {
	loadJS('/dynamic/js/session/0/0.js', { async: false, defer: false });
}

// TODO: This needs to be removed after a couple of months of cleanup
try {
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (-1 !== key.indexOf(encodeURIComponent('dynamic/js/session'))) {
			console.info(`Removing stored session data: ${ key }`);
			localStorage.removeItem(key);
		}
	}
} catch (e) {
	console.error(e);
}

InterNACHI.session.onLoaded(() => {
	try {
		localStorage.setItem('internachi_session', JSON.stringify({
			session_js: session,
			logged_in_user: window.logged_in_user,
			algolia: window.algolia,
			// ziggy_routes: window.Ziggy.namedRoutes,
		}));
	} catch (e) {
		console.error(e);
	}
});

InterNACHI.session.onGuest(() => {
	try {
		localStorage.setItem('internachi_session', JSON.stringify({
			session_js: null,
			logged_in_user: null,
			algolia: window.algolia,
			// ziggy_routes: window.Ziggy.namedRoutes,
		}));
	} catch (e) {
		console.error(e);
	}
});
